import { useMutation } from '@tanstack/react-query';

import { automationServices } from '@hero/services';

export const useDuplicateAutomation = ({ options = {} } = {}) =>
  useMutation(({ code, body }) => automationServices.duplicate(code, body), options);
